export abstract class SubtitleRepository {
  downloadSubtitle: (url: string) => Promise<string>;

  getSubtitleURL: (subtitleId: number) => Promise<any>;

  getClosedCaptionOriginalURL: (subtitleId: number) => Promise<any>;
}
